// setShouldDisplayAsideModuleHint.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set should display aside module hint
 * @kind action
 * @param {boolean} shouldDisplayAsideModuleHint - If true, the aside module hint will be shown; otherwise, it will be hidden.
 * @return {Object} Action.
 */
const setShouldDisplayAsideModuleHint =
  ({ shouldDisplayAsideModuleHint }) =>
  dispatch =>
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['liveStream'],
        data: {
          shouldDisplayAsideModuleHint,
        },
      },
    });

export default setShouldDisplayAsideModuleHint;
